import request from '@/utils/request'
// 北向资金：个股成交统计
export function ggcjtj(query) {
    return request({
        url: '/Bxzj/ggcjtj',
        method: 'get',
        params: query
    })
}

export function ggtj(query) {
    return request({
        url: '/Bxzj/ggtj',
        method: 'get',
        params: query
    })
}

// 北向资金：行业偏好
export function hyph(query) {
    return request({
        url: '/Bxzj/hyph',
        method: 'get',
        params: query
    })
}
